import React from 'react';
import { Grid, Autocomplete, TextField } from '@mui/material';
import { bpOptions, heartRateOptions, oxygenLevelOptions, temperatureOptions, medicationOptions, dosageOptions } from '../constants/options';

const VitalsAndMedicationSection = ({ formData, handleChange, errors, onBlur, setFormData }) => {
  return (
    <Grid container spacing={2} sx={{ mt: 1 }}>
      <Grid item xs={12} sm={6}>
        <Autocomplete
          freeSolo
          options={bpOptions}
          value={formData.bp || ''}
          onChange={(e, val) => setFormData(prev => ({ ...prev, bp: val }))}
          renderInput={(params) => (
            <TextField
              {...params}
              label={<span>BP (Blood Pressure) <span style={{ color: '#ff0000' }}>*</span></span>}
              name="bp"
              onBlur={onBlur}
              error={!!errors.bp}
              helperText={errors.bp || ' '}
              onChange={handleChange}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Autocomplete
          freeSolo
          options={heartRateOptions}
          value={formData.heart_rate || ''}
          onChange={(e, val) => setFormData(prev => ({ ...prev, heart_rate: val }))}
          renderInput={(params) => (
            <TextField
              {...params}
              label={<span>Heart Rate <span style={{ color: '#ff0000' }}>*</span></span>}
              name="heart_rate"
              onBlur={onBlur}
              error={!!errors.heart_rate}
              helperText={errors.heart_rate || ' '}
              onChange={handleChange}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Autocomplete
          freeSolo
          options={oxygenLevelOptions}
          value={formData.oxygen_levels || ''}
          onChange={(e, val) => setFormData(prev => ({ ...prev, oxygen_levels: val }))}
          renderInput={(params) => (
            <TextField {...params} label="Oxygen Levels (%)" name="oxygen_levels" onChange={handleChange} />
          )}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Autocomplete
          freeSolo
          options={temperatureOptions}
          value={formData.temperature || ''}
          onChange={(e, val) => setFormData(prev => ({ ...prev, temperature: val }))}
          renderInput={(params) => (
            <TextField {...params} label="Temperature (°C)" name="temperature" onChange={handleChange} />
          )}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Autocomplete
          freeSolo
          options={medicationOptions}
          value={formData.last_medication_taken || ''}
          onChange={(e, val) => setFormData(prev => ({ ...prev, last_medication_taken: val }))}
          renderInput={(params) => (
            <TextField {...params} label="Last Medication Taken" name="last_medication_taken" onChange={handleChange} />
          )}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Autocomplete
          freeSolo
          options={dosageOptions}
          value={formData.dosage || ''}
          onChange={(e, val) => setFormData(prev => ({ ...prev, dosage: val }))}
          renderInput={(params) => (
            <TextField {...params} label="Dosage" name="dosage" onChange={handleChange} />
          )}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          label="Time"
          name="time"
          type="time"
          value={formData.time || ''}
          onChange={handleChange}
          fullWidth
          InputLabelProps={{
            shrink: true
          }}
        />
      </Grid>
    </Grid>
  );
};

export default VitalsAndMedicationSection;
